(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qc-collection-premium"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qc-orbit-showcase')) {
    class QcOrbitShowcase extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.controller = new AbortController();
        this.signal = this.controller.signal;
        this.stage = this.querySelector('[data-qc-stage]');
        this.cards = Array.from(this.querySelectorAll('[data-qc-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-qc-dot]'));
        this.currentLabels = Array.from(this.querySelectorAll('[data-qc-current]'));
        this.prevButton = this.querySelector('[data-qc-prev]');
        this.nextButton = this.querySelector('[data-qc-next]');
        this.activeIndex = 0;
        this.autoplayTimer = null;
        this.isInView = true;
        this.isHovered = false;
        this.isFocused = false;
        this.isDragging = false;
        this.dragStartX = 0;
        this.dragDelta = 0;
        this.ignoreNextClick = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        if (!this.stage || this.cards.length === 0) {
          this.reveal();
          return;
        }

        this.layoutCards(false);
        this.bindEvents();
        this.observe();
        this.startAutoplay();
      }

      bindEvents() {
        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.goTo(this.activeIndex - 1, 'manual'), { signal: this.signal });
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.goTo(this.activeIndex + 1, 'manual'), { signal: this.signal });
        }

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.qcDot), 'manual'), { signal: this.signal });
        });

        this.cards.forEach((card, index) => {
          card.addEventListener(
            'click',
            (event) => {
              if (this.ignoreNextClick) {
                event.preventDefault();
              }
            },
            { signal: this.signal }
          );

          card.addEventListener(
            'pointermove',
            (event) => {
              if (!this.finePointer || this.reducedMotion || index !== this.activeIndex || this.isDragging) return;
              if (event.target.closest('.qc-orbit__cta')) {
                this.resetTilt(card);
                return;
              }
              this.updateTilt(card, event);
            },
            { passive: true, signal: this.signal }
          );

          card.addEventListener('pointerleave', () => this.resetTilt(card), { signal: this.signal });
        });

        this.stage.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal: this.signal });
        this.stage.addEventListener('pointermove', (event) => this.onPointerMove(event), { signal: this.signal });
        this.stage.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal: this.signal });
        this.stage.addEventListener('pointercancel', (event) => this.onPointerUp(event), { signal: this.signal });

        this.stage.addEventListener(
          'keydown',
          (event) => {
            if (event.key === 'ArrowLeft') {
              event.preventDefault();
              this.goTo(this.activeIndex - 1, 'manual');
            }
            if (event.key === 'ArrowRight') {
              event.preventDefault();
              this.goTo(this.activeIndex + 1, 'manual');
            }
          },
          { signal: this.signal }
        );

        this.addEventListener(
          'pointerenter',
          () => {
            this.isHovered = true;
            this.stopAutoplay();
          },
          { signal: this.signal }
        );

        this.addEventListener(
          'pointerleave',
          () => {
            this.isHovered = false;
            this.startAutoplay();
          },
          { signal: this.signal }
        );

        this.addEventListener(
          'focusin',
          () => {
            this.isFocused = true;
            this.stopAutoplay();
          },
          { signal: this.signal }
        );

        this.addEventListener(
          'focusout',
          () => {
            window.setTimeout(() => {
              this.isFocused = this.contains(document.activeElement);
              this.startAutoplay();
            }, 0);
          },
          { signal: this.signal }
        );

        document.addEventListener(
          'visibilitychange',
          () => {
            if (document.hidden) this.stopAutoplay();
            else this.startAutoplay();
          },
          { signal: this.signal }
        );
      }

      observe() {
        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          this.reveal();
          return;
        }

        this.classList.add('is-observed');
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.isInView = entry.isIntersecting;
              if (entry.isIntersecting) {
                this.reveal();
                this.startAutoplay();
              } else {
                this.stopAutoplay();
              }
            });
          },
          { threshold: 0.18 }
        );
        this.observer.observe(this);
      }

      reveal() {
        this.classList.add('is-visible');
      }

      getWrappedIndex(index) {
        const length = this.cards.length;
        return ((index % length) + length) % length;
      }

      getRelativeSlot(index) {
        const length = this.cards.length;
        let difference = index - this.activeIndex;

        if (difference > length / 2) difference -= length;
        if (difference < -length / 2) difference += length;

        if (difference < -2 || difference > 2) return 'hidden';
        return String(difference);
      }

      layoutCards(announce = true) {
        this.cards.forEach((card, index) => {
          const slot = this.getRelativeSlot(index);
          const isActive = index === this.activeIndex;
          card.dataset.slot = slot;
          card.classList.toggle('is-active', isActive);
          card.tabIndex = isActive ? 0 : -1;
          card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
          if (!isActive) this.resetTilt(card);
        });

        this.dots.forEach((dot, index) => {
          const isActive = index === this.activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        this.currentLabels.forEach((label) => {
          label.textContent = String(this.activeIndex + 1).padStart(2, '0');
        });

        if (announce) this.restartAutoplay();
      }

      goTo(index, source = 'manual') {
        if (this.cards.length < 2) return;
        this.activeIndex = this.getWrappedIndex(index);
        this.layoutCards(source === 'manual');
      }

      updateTilt(card, event) {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        const rotateY = (x - 0.5) * 7;
        const rotateX = (0.5 - y) * 5;

        card.style.setProperty('--qc-tilt-x', `${rotateX}deg`);
        card.style.setProperty('--qc-tilt-y', `${rotateY}deg`);
        card.style.setProperty('--qc-image-x', `${(x - 0.5) * 8}px`);
        card.style.setProperty('--qc-image-y', `${(y - 0.5) * 6}px`);
        card.style.setProperty('--qc-pointer-x', `${x * 100}%`);
        card.style.setProperty('--qc-pointer-y', `${y * 100}%`);
      }

      resetTilt(card) {
        card.style.setProperty('--qc-tilt-x', '0deg');
        card.style.setProperty('--qc-tilt-y', '0deg');
        card.style.setProperty('--qc-image-x', '0px');
        card.style.setProperty('--qc-image-y', '0px');
        card.style.setProperty('--qc-pointer-x', '72%');
        card.style.setProperty('--qc-pointer-y', '28%');
      }

      onPointerDown(event) {
        if (this.cards.length < 2 || event.button !== 0) return;
        this.isDragging = true;
        this.dragStartX = event.clientX;
        this.dragDelta = 0;
        this.ignoreNextClick = false;
        this.stopAutoplay();
      }

      onPointerMove(event) {
        if (!this.isDragging) return;
        this.dragDelta = event.clientX - this.dragStartX;
        if (Math.abs(this.dragDelta) <= 7) return;

        this.ignoreNextClick = true;
        this.stage.classList.add('is-dragging');
        if (!this.stage.hasPointerCapture(event.pointerId)) {
          this.stage.setPointerCapture(event.pointerId);
        }

        const resistance = Math.max(-90, Math.min(90, this.dragDelta * 0.32));
        this.stage.style.setProperty('--qc-drag-shift', `${resistance}px`);
      }

      onPointerUp(event) {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.stage.classList.remove('is-dragging');
        this.stage.style.setProperty('--qc-drag-shift', '0px');

        if (this.stage.hasPointerCapture(event.pointerId)) {
          this.stage.releasePointerCapture(event.pointerId);
        }

        if (Math.abs(this.dragDelta) > 42) {
          this.goTo(this.activeIndex + (this.dragDelta < 0 ? 1 : -1), 'manual');
        } else {
          this.startAutoplay();
        }

        window.setTimeout(() => {
          this.ignoreNextClick = false;
        }, 0);
      }

      canAutoplay() {
        return (
          this.dataset.autoplay === 'true' &&
          !this.reducedMotion &&
          this.cards.length > 1 &&
          this.isInView &&
          !this.isHovered &&
          !this.isFocused &&
          !this.isDragging &&
          !document.hidden
        );
      }

      startAutoplay() {
        this.stopAutoplay();
        if (!this.canAutoplay()) return;

        const delay = Math.max(3200, Number(this.dataset.autoplaySpeed) || 5200);
        window.requestAnimationFrame(() => {
          if (this.canAutoplay()) this.classList.add('is-autoplaying');
        });

        this.autoplayTimer = window.setTimeout(() => {
          this.goTo(this.activeIndex + 1, 'autoplay');
          this.startAutoplay();
        }, delay);
      }

      stopAutoplay() {
        if (this.autoplayTimer) {
          window.clearTimeout(this.autoplayTimer);
          this.autoplayTimer = null;
        }
        this.classList.remove('is-autoplaying');
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
        if (this.controller) this.controller.abort();
        if (this.observer) this.observer.disconnect();
      }
    }

    customElements.define('qc-orbit-showcase', QcOrbitShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-transition-narrative"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('qc-narrative-transition')) {
    class QCNarrativeTransition extends HTMLElement {
      connectedCallback() {
        if (this.dataset.qcReady === 'true') return;
        this.dataset.qcReady = 'true';

        this.video = this.querySelector('video');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.pointerMoveHandler = this.handlePointerMove.bind(this);
        this.pointerResetHandler = this.resetPointer.bind(this);

        if (this.reducedMotion) {
          this.classList.add('is-visible');
          if (this.video) this.video.pause();
        } else {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('is-visible', entry.isIntersecting);
                if (!this.video) return;

                if (entry.isIntersecting) {
                  const playPromise = this.video.play();
                  if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(() => {});
                } else {
                  this.video.pause();
                }
              });
            },
            { threshold: 0.18 }
          );

          this.observer.observe(this);

          if (this.classList.contains('qc-transition--product-media') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
            this.addEventListener('pointermove', this.pointerMoveHandler);
            this.addEventListener('pointerleave', this.pointerResetHandler);
          }
        }

        QCNarrativeTransition.initializeStoryline();
        QCNarrativeTransition.initializeWhyCarousel();
        QCNarrativeTransition.scheduleStoryline();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.removeEventListener('pointermove', this.pointerMoveHandler);
        this.removeEventListener('pointerleave', this.pointerResetHandler);
        QCNarrativeTransition.scheduleStoryline();
      }

      handlePointerMove(event) {
        const rect = this.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 10;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * 8;
        this.style.setProperty('--qc-media-x', `${x}px`);
        this.style.setProperty('--qc-media-y', `${y}px`);
      }

      resetPointer() {
        this.style.setProperty('--qc-media-x', '0px');
        this.style.setProperty('--qc-media-y', '0px');
      }

      static initializeStoryline() {
        if (this.storylineInitialized) return;
        this.storylineInitialized = true;

        window.addEventListener('resize', () => this.scheduleStoryline(), { passive: true });
        window.addEventListener(
          'scroll',
          () => {
            if (this.storylineScrollFrame) return;
            this.storylineScrollFrame = requestAnimationFrame(() => {
              this.storylineScrollFrame = null;
              this.updateStoryProgress();
            });
          },
          { passive: true }
        );

        document.addEventListener('shopify:section:load', () => {
          this.initializeWhyCarousel();
          this.scheduleStoryline();
        });
        document.addEventListener('shopify:section:reorder', () => this.scheduleStoryline());

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.scheduleStoryline());
        }
      }

      static scheduleStoryline() {
        if (this.storylineRenderFrame) cancelAnimationFrame(this.storylineRenderFrame);
        this.storylineRenderFrame = requestAnimationFrame(() => {
          this.storylineRenderFrame = null;
          this.renderStoryline();
        });
      }

      static initializeWhyCarousel() {
        const root = document.querySelector('#qcWhy2');
        const list = root ? root.querySelector('.qw2-list') : null;
        if (!list) return;

        /* Le ruban est gere par qc-why-buy : aucun slider, compteur ou scroll automatique ici. */
        list.dataset.qcMobileCarousel = 'continuous';
        root.querySelectorAll('.qc-why-mobile-meter').forEach((meter) => meter.remove());
      }

      static initializeStorySections() {
        const chapters = [
          document.querySelector('.qc-ae2__inner'),
          document.querySelector('#qcWhy2')
        ].filter(Boolean);
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        chapters.forEach((chapter, index) => {
          chapter.classList.add('qc-story-proof', `qc-story-proof--${index + 1}`);

          const wrapper = chapter.closest('.shopify-section');
          if (wrapper) wrapper.classList.add('qc-story-chapter');
          if (chapter.dataset.qcStoryReady === 'true') return;

          chapter.dataset.qcStoryReady = 'true';
          if (reducedMotion || !('IntersectionObserver' in window)) {
            chapter.classList.add('qc-story-visible', 'qc-story-settled');
            return;
          }

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                chapter.classList.add('qc-story-visible');
                window.setTimeout(() => chapter.classList.add('qc-story-settled'), 950);
                observer.disconnect();
              });
            },
            { threshold: 0.12, rootMargin: '0px 0px -12% 0px' }
          );

          observer.observe(chapter);
        });

        const endChapter = document.querySelector('.qc-orbit');
        const endWrapper = endChapter && endChapter.closest('.shopify-section');
        if (endWrapper) endWrapper.classList.add('qc-story-chapter', 'qc-story-chapter--end');
      }

      static renderStoryline() {
        this.initializeStorySections();

        const transitions = Array.from(
          document.querySelectorAll('qc-narrative-transition[data-story-line="true"]')
        ).filter((transition) => transition.offsetParent !== null);
        const main = document.querySelector('main');

        const startChapter = document.querySelector('.qc-ae2__inner');
        const middleChapter = document.querySelector('#qcWhy2');
        const endChapter = document.querySelector('.qc-orbit__shell') || document.querySelector('.qc-orbit');

        if (!main || transitions.length < 2 || !startChapter || !middleChapter || !endChapter) {
          const existing = document.querySelector('.qc-storyline');
          if (existing) existing.remove();
          return;
        }

        const firstNode = transitions[0].querySelector('.qc-transition__story-node');
        const lastNode = transitions[transitions.length - 1].querySelector('.qc-transition__story-node');
        if (!firstNode || !lastNode) return;

        main.classList.add('qc-storyline-host');

        const namespace = 'http://www.w3.org/2000/svg';
        let svg = main.querySelector(':scope > .qc-storyline');

        if (!svg) {
          svg = document.createElementNS(namespace, 'svg');
          svg.classList.add('qc-storyline');
          svg.setAttribute('aria-hidden', 'true');

          const basePath = document.createElementNS(namespace, 'path');
          basePath.classList.add('qc-storyline__base');
          const progressPath = document.createElementNS(namespace, 'path');
          progressPath.classList.add('qc-storyline__progress');
          const cursor = document.createElementNS(namespace, 'rect');
          cursor.classList.add('qc-storyline__cursor');
          cursor.setAttribute('x', '-10');
          cursor.setAttribute('y', '-2');
          cursor.setAttribute('width', '20');
          cursor.setAttribute('height', '4');
          cursor.setAttribute('rx', '2');

          svg.append(basePath, progressPath, cursor);
          main.append(svg);
        }

        const mainRect = main.getBoundingClientRect();
        const firstRect = firstNode.getBoundingClientRect();
        const lastRect = lastNode.getBoundingClientRect();
        const startRect = startChapter.getBoundingClientRect();
        const middleRect = middleChapter.getBoundingClientRect();
        const endRect = endChapter.getBoundingClientRect();
        const width = main.clientWidth;
        const height = main.scrollHeight;
        const firstX = firstRect.left - mainRect.left + firstRect.width / 2;
        const firstY = firstRect.top - mainRect.top + firstRect.height / 2;
        const lastX = lastRect.left - mainRect.left + lastRect.width / 2;
        const lastY = lastRect.top - mainRect.top + lastRect.height / 2;
        const startY = startRect.top - mainRect.top + Math.min(54, startRect.height * 0.08);
        const endY = endRect.top - mainRect.top - 5;
        const mobile = window.matchMedia('(max-width: 749px)').matches;

        let pathData;
        if (mobile) {
          const guideX = firstX;
          pathData = [
            `M ${guideX} ${startY}`,
            `L ${guideX} ${firstY}`,
            `L ${guideX} ${lastY}`,
            `L ${guideX} ${endY}`
          ].join(' ');
        } else {
          const startX = Math.max(28, startRect.left - mainRect.left - 28);
          const startBottomY = startRect.bottom - mainRect.top - 44;
          const middleSideX = Math.max(28, middleRect.left - mainRect.left - 44);
          const middleTopY = middleRect.top - mainRect.top + 34;
          const middleBottomY = middleRect.bottom - mainRect.top - 34;
          const endX = endRect.left - mainRect.left + endRect.width / 2;

          pathData = [
            `M ${startX} ${startY}`,
            `C ${startX} ${startY + 92}, ${startX} ${startBottomY - 70}, ${startX} ${startBottomY}`,
            `C ${startX} ${startBottomY + 54}, ${firstX - 108} ${firstY - 46}, ${firstX} ${firstY}`,
            `C ${firstX + 34} ${firstY + 58}, ${middleSideX} ${middleTopY - 66}, ${middleSideX} ${middleTopY}`,
            `L ${middleSideX} ${middleBottomY}`,
            `C ${middleSideX} ${middleBottomY + 62}, ${lastX - 78} ${lastY - 58}, ${lastX} ${lastY}`,
            `C ${lastX} ${lastY + 58}, ${endX} ${endY - 72}, ${endX} ${endY}`
          ].join(' ');
        }

        svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
        svg.setAttribute('width', String(width));
        svg.setAttribute('height', String(height));
        svg.style.height = `${height}px`;

        const basePath = svg.querySelector('.qc-storyline__base');
        const progressPath = svg.querySelector('.qc-storyline__progress');
        basePath.setAttribute('d', pathData);
        progressPath.setAttribute('d', pathData);

        const pathLength = progressPath.getTotalLength();
        progressPath.style.strokeDasharray = String(pathLength);
        progressPath.dataset.pathLength = String(pathLength);
        svg.dataset.startY = String(startRect.top + window.scrollY + Math.min(54, startRect.height * 0.08));
        svg.dataset.endY = String(endRect.top + window.scrollY - 5);

        this.updateStoryProgress();
      }

      static updateStoryProgress() {
        const svg = document.querySelector('.qc-storyline');
        if (!svg) return;

        const progressPath = svg.querySelector('.qc-storyline__progress');
        const pathLength = Number(progressPath.dataset.pathLength || 0);
        const startY = Number(svg.dataset.startY || 0);
        const endY = Number(svg.dataset.endY || 0);
        if (!pathLength || endY <= startY) return;

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const readingLine = window.scrollY + window.innerHeight * 0.7;
        const progress = reducedMotion ? 1 : Math.min(1, Math.max(0, (readingLine - startY) / (endY - startY)));
        progressPath.style.strokeDashoffset = String(pathLength * (1 - progress));

        const cursor = svg.querySelector('.qc-storyline__cursor');
        if (!cursor) return;

        const distance = Math.min(pathLength, Math.max(0, pathLength * progress));
        const beforeDistance = Math.max(0, distance - 1);
        const afterDistance = Math.min(pathLength, distance + 1);
        const point = progressPath.getPointAtLength(distance);
        const before = progressPath.getPointAtLength(beforeDistance);
        const after = progressPath.getPointAtLength(afterDistance);
        const angle = Math.atan2(after.y - before.y, after.x - before.x) * (180 / Math.PI);

        cursor.setAttribute('transform', `translate(${point.x} ${point.y}) rotate(${angle})`);
        cursor.style.opacity = !reducedMotion && progress > 0.015 && progress < 0.985 ? '1' : '0';
      }
    }

    customElements.define('qc-narrative-transition', QCNarrativeTransition);
  }

  } catch(e) { console.error(e); }
})();
})();
